import { Theme, themesMap } from '@components/undock/modules'
import styled from '@emotion/styled'
import { mediaQueries } from '@lib/mediaQueries'

interface CardPropsI {
  borderColor?: string
  theme?: Theme
}
const Card = styled.div<CardPropsI>(
  mediaQueries({
    border: 'solid 1px',
    borderRadius: '1.5rem',
    padding: '2rem',
    '&:not(:first-of-type)': {
      marginTop: ['2rem', '2rem', '2rem', 0, 0],
    },
  }),
  ({ borderColor = null, theme = themesMap.light }) => ({
    backgroundColor: theme.colors.cardBackgroundColor,
    borderColor: borderColor ? borderColor : theme.colors.cardBorderColor,
    color: theme.colors.textColor,
  })
)

export default Card
